import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-multi-select',
    templateUrl: './app-multi-select.component.html'
})
export class AppMultiSelectComponent {
    @Input() options: any[];
}
